var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.templatesList,"label":_vm.$t('Template'),"item-text":"name","item-value":"code"},model:{value:(_vm.template),callback:function ($$v) {_vm.template=$$v},expression:"template"}})}
var staticRenderFns = []

export { render, staticRenderFns }